import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { pages } from '@/settings/pages';
import { NameEditFormContainer } from '@/components/pages/Account/NameEdit/NameEditForm';

export const AccountNameEditPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.account.name.edit.title');

  return (
    <PageRootWrapper
      title={title}
      headerTitle={title}
      hasHeaderDivider={true}
      breadcrumbItems={[
        {
          label: t('pages.account.index.title'),
          path: pages.account.index,
        },
        { label: title },
      ]}
      containerType="normal"
    >
      <NameEditFormContainer />
    </PageRootWrapper>
  );
};
